import setTargetOnOrderItems from '../actions/setTargetOnOrderItems'
import { props, state } from 'cerebral/tags'
import { set, unset } from 'cerebral/operators'
import setSizeOnOrderItem from '../actions/setSizeOnOrderItem'

export default [
  function({ props }) {
    return { ids: [`"${props.orderItemId}"`] }
  },
  setTargetOnOrderItems,
  set(
    state`basket.basketItems.${props`orderItemId`}.target`,
    props`orderItem.target`
  ),
  unset(state`basket.basketItems.${props`orderItemId`}.error`),
  set(state`basket.basketItems.${props`orderItemId`}.done`, true),
  setSizeOnOrderItem
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/setTarget.js